import ApiClient from './ApiClient'

export default class FindATutorService {

  constructor() {
      this.apiClient = new ApiClient()
  }

  submitFindMeATutor(enquiry) {
    return this.apiClient.create().post('findatutor', enquiry)
  }

  submitFindMeATutorNew(enquiry) {
    return this.apiClient.create().post('findatutor/new', enquiry)
  }

}